import {TypologyLabel} from '@modules/activities/core/models/typology.label';
import {GranuleMetadata} from 'shared/models/granule';

export interface ActivityMetaEntityAttributes extends GranuleMetadata {
    typology: {
        id: string,
        label: TypologyLabel
    },
}
